/**
 * @overview 预约日历
 * @author jzhu
 * @date 2020-8-14
 */

import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '../../../../tool'
let { WizContainer, modelUtils } = framework_tool
let { WizModal, WizSpin, WizInput, WizRow, WizCol, WizButton, WizIcon } = component_tool
let { dateUtils } = utils_tool
import WizCalendar from '../../../demo/wizCalendarDemo/wizCalendar'
import './index.less'
import classNames from 'classnames'

class AppointmentCalendar extends WizContainer {

    componentName = 'AppointmentCalendar'

    constructor(props) {
        super(props)
        let now = new Date()
        let year = now.getFullYear()
        let month = now.getMonth() + 1
        this.state = {
            siteId: props.siteId,
            visible: false,
            year,
            month,
            mouse: {},
            selected: {
                start: {},
                end: {}
            },
            today: now,
            cellMap: {},
            timeStamp: new Date().getTime()
        }
    }

    static defaultProps = {
        mode: 'edit',//edit 编辑  show 查看
    }

    _componentDidMount = () => {
        this._getAppointmentInfo()
    }

    _getTimeQuantum = () => {
        let { year, month } = this.state
        let endDay = WizCalendar.Utils.monthDays(year, month)
        let start = dateUtils.formatDate(new Date(year, month - 1, 1), 'yyyy-MM-dd') + ' 00:00:00'
        let end = dateUtils.formatDate(new Date(year, month - 1, endDay), 'yyyy-MM-dd') + ' 23:59:59'
        return { start, end }
    }

    _getAppointmentInfo = () => {
        if (this.props.siteId) {
            let { start, end } = this._getTimeQuantum()
            this.doAction({
                path: 'siteOrder/list',
                payload: {
                    key: 'appointmentCalendarList',
                    apiParams: {
                        siteId: this.props.siteId,
                        startDate: start,
                        endDate: end,
                        // status: 1,
                        statusList: [0, 1]
                    }
                }
            })
        }
    }

    propsAndStateOnChange = {
        list: this._listOnChange.bind(this)
    }

    _listOnChange(nextProps, nextState) {
        if (nextProps.list.code === 1) {
            let { today, list } = nextProps.list.data
            nextState.today = new Date(today)
            let map = this._updateCellMap(list)
            Object.keys(map).forEach(key => {
                nextState.cellMap[key] = map[key]
            })
        }
        return true
    }

    _updateCellMap = (list) => {
        let map = {}
        if (list && list.length) {
            list.forEach(item => {
                let { start, end } = item
                let startDate = new Date(start)
                let endDate = new Date(end)
                while (startDate.getTime() <= endDate.getTime()) {
                    let sy = startDate.getFullYear()
                    let sm = startDate.getMonth() + 1
                    let sd = startDate.getDate()
                    if (map[sy + '-' + sm]) {
                        map[sy + '-' + sm][sd] = item
                    } else {
                        map[sy + '-' + sm] = { [sd]: item }
                    }
                    startDate = startDate.setDate(startDate.getDate() + 1)
                    startDate = new Date(startDate)
                }
            })
        } else {
            let { year, month } = this.state
            map[year + '-' + month] = {}
        }
        return map
    }

    _onAppointment = () => {
        let { start, end } = this.state.selected
        let sl = Object.keys(start).length
        let el = Object.keys(end).length
        let value = {}
        if (sl && el) {
            if (!this._check(start, end)) {
                wizNotice.error('预约时间段内该场地已被预约')
                return
            }
            value.start = new Date(start.year, start.month - 1, start.day)
            value.end = new Date(end.year, end.month - 1, end.day)
        } else if (sl) {
            if (!this._check(start)) {
                wizNotice.error('预约时间段内该场地已被预约')
                return
            }
            value.start = new Date(start.year, start.month - 1, start.day)
            value.end = new Date(start.year, start.month - 1, start.day)
        } else {
            value = undefined
        }
        this.props.onChange && this.props.onChange(value)
        this.setState({ visible: false })
    }

    _check = (start, end) => {
        let { cellMap } = this.state
        let result = true
        let sy = start.year
        let sm = start.month
        let sd = start.day
        if (end) {
            let usedArr = []
            let keys = Object.keys(cellMap)
            if (keys && keys.length) {
                keys.forEach(key => {
                    let days = Object.keys(cellMap[key])
                    if (days && days.length) {
                        let arr = key.split('-')
                        let year = arr[0]
                        let month = arr[1].length === 1 ? '0' + arr[1] : arr[1]
                        days.forEach(day => {
                            day = day.length === 1 ? '0' + day : day
                            let used = parseInt(year + month + day)
                            usedArr.push(used)
                        })
                    }
                })

            }
            sm = sm > 9 ? '' + sm : '0' + sm
            sd = sd > 9 ? '' + sd : '0' + sd
            let s = parseInt(sy + sm + sd)
            let ey = end.year
            let em = end.month > 9 ? '' + end.month : '0' + end.month
            let ed = end.day > 9 ? '' + end.day : '0' + end.day
            let e = parseInt(ey + em + ed)
            usedArr.length && usedArr.forEach(used => {
                if (s <= used && used <= e) {
                    result = false
                }
            })
        } else {
            let monthMap = cellMap[sy + '-' + sm]
            if (monthMap && monthMap[sd]) {
                result = false
            }
        }
        return result
    }

    _renderHeader = (year, month) => {
        let { mode } = this.props
        return (
            <div >
                <WizRow className='header-row' type='flex' justify='center'>
                    <WizCol className='header-col' span={5}>
                        <div>
                            <WizButton title='上月' icon='left' onClick={() => this._calendar && this._calendar._onLast()} />
                            <WizButton title='下月' icon='right' onClick={() => this._calendar && this._calendar._onNext()} />
                            <WizButton title='今天' onClick={() => this._calendar && this._calendar._onToday()} >今天</WizButton>
                        </div>
                    </WizCol>
                    <WizCol className='header-col' span={12}>
                        <div className='header-title'>
                            {year + '年' + month + '月'}
                        </div>
                    </WizCol>
                    <WizCol className='header-col' span={3} offset={2}>
                        {
                            mode === 'edit' ?
                                <div>
                                    <WizButton title='预约' type='primary' onClick={() => this._onAppointment()} >预约</WizButton>
                                </div> : <></>
                        }
                    </WizCol>
                </WizRow>
            </div>
        )
    }

    _onPanelChange = ({ year, month }) => {
        if (this.state.year !== year || this.state.month !== month) {
            this.setState({ year, month, timeStamp: new Date().getTime() }, () => {
                this._getAppointmentInfo()
            })
        }
    }

    _onMouseOver = (date) => {
        this.setState({ mouse: date, timeStamp: new Date().getTime() })
    }

    _onMouseOut = () => {
        this.setState({ mouse: {}, timeStamp: new Date().getTime() })
    }

    _onDate = (date) => {
        let { start, end } = this.state.selected
        let sl = Object.keys(start).length
        let el = Object.keys(end).length
        if (sl && el) {
            this.setState({ selected: { start: date, end: {} }, timeStamp: new Date().getTime() })
        } else if (sl) {
            if (WizCalendar.Utils.equalsObjProperty(start, date)) {
                return
            } else {
                if (WizCalendar.Utils.isAfterDate(start, date)) {
                    this.setState({ selected: { start, end: date }, timeStamp: new Date().getTime() })
                } else {
                    this.setState({ selected: { start: date, end: start }, timeStamp: new Date().getTime() })
                }
            }
        } else {
            this.setState({ selected: { start: date, end: {} }, timeStamp: new Date().getTime() })
        }
    }

    _isSelected = (date) => {
        let { start, end } = this.state.selected
        if (WizCalendar.Utils.equalsObjProperty(date, end)
            || WizCalendar.Utils.equalsObjProperty(date, start)) {
            return true
        }
        let sl = Object.keys(start).length
        let el = Object.keys(end).length
        if (sl && el) {
            if (WizCalendar.Utils.isAfterDate(start, date)
                && !WizCalendar.Utils.isAfterDate(end, date)) {
                return true
            }
        }
        return false
    }

    _renderCell = (date, disabled) => {
        let { year, month, day } = date
        let { cellMap } = this.state
        let {mode} = this.props
        if (cellMap[year + '-' + month] && cellMap[year + '-' + month][day]) {
            let { fullName, orderMobile, orderPersonId } = cellMap[year + '-' + month][day]
            let _class = mode === 'show' ? 'appointment-show-text' : disabled ? 'no-appointment-before' : 'no-appointment'
            return (
                <>
                    <div className={_class}>
                        {'预约人:' + (fullName || '')}
                    </div>
                    <div className={_class}>
                        {'电话:' + (orderMobile || '')}
                    </div>
                </>
            )
        } else if (!disabled) {
            return (
                <div className='appointment-available'>
                    {'可预约'}
                </div>
            )
        }
    }

    _renderDate = (info) => {
        let { mode } = this.props
        let { date, status } = info
        let day = date.day < 10 ? '0' + date.day : date.day
        let _class = 'appointment-date'
        if (date.month !== this.state.month || date.year !== this.state.year) {
            return <div className='appointment-calendar' />
        }
        if (!status.isBefore) {
            let isSelected = this._isSelected(date)
            if (status.isToday) {
                _class = classNames(_class, 'appointment-today')
            } else if (WizCalendar.Utils.equalsObjProperty(date, this.state.mouse)) {
                _class = classNames(_class, 'appointment-mouse')
            }
            if (isSelected) {
                _class = classNames(_class, 'appointment-selected')
            }
            let divState = mode === 'edit' ? {
                onMouseOver: () => this._onMouseOver(date),
                onMouseOut: () => this._onMouseOut(),
                onClick: () => this._onDate(date)
            } : {}
            return (
                <div
                    className='appointment-calendar'
                    {...divState}
                >
                    <div className={_class}>
                        <div className='day'>
                            {day}
                        </div>
                        <div className='cell'>
                            {this._renderCell(date, mode === 'show')}
                        </div>
                    </div>
                </div>
            )
        } else {
            _class = mode === 'edit' ? classNames(_class, 'appointment-before') : ''
            return (
                <div className='appointment-calendar'>
                    <div className={_class}>
                        <div className='day'>
                            {day}
                        </div>
                        <div className='cell'>
                            {this._renderCell(date, true)}
                        </div>
                    </div>
                </div>
            )
        }
    }

    _renderCalendar = () => {
        return (
            <WizSpin tip={'加载中'} spinning={this.props.siteOrderLoading}>
                <WizCalendar
                    ref={ref => this._calendar = ref}
                    today={this.state.today}
                    onPanelChange={this._onPanelChange}
                    renderHeader={this._renderHeader}
                    weekTitle={['周日', '周一', '周二', '周三', '周四', '周五', '周六']}
                    disabled={WizCalendar.DISABLED_BEFORE}
                    renderDate={this._renderDate}
                    timeStamp={this.state.timeStamp}
                />
            </WizSpin>
        )
    }

    _renderModal = () => {
        return (
            <WizModal
                className='appointment-calendar-modal'
                visible={this.state.visible}
                closable={false}
                width={1200}
                footer={null}
                onCancel={() => this.setState({ visible: false })}
            >
                {this._renderCalendar()}
                <div className='appointment-calendar-tooltip'>
                    <WizIcon className='icon' type='question-circle-o' />
                    {'注：灰色为不可预约时间段，预约时请点击单元格进行预约，请依次点击单元格来选择预约的开始时间和结束时间'}
                </div>
            </WizModal>
        )
    }

    _renderInput = () => {
        let value = ''
        if (this.props.value) {
            let { start, end } = this.props.value
            if (start) {
                let year = start.getFullYear()
                let month = start.getMonth() + 1
                let day = start.getDate()
                value = year + '-' + (month > 9 ? month : '0' + month) + '-' + (day > 9 ? day : '0' + day)
            }
            if (end) {
                let year = end.getFullYear()
                let month = end.getMonth() + 1
                let day = end.getDate()
                value += ' ~ ' + year + '-' + (month > 9 ? month : '0' + month) + '-' + (day > 9 ? day : '0' + day)
            }
        }
        return (
            <div onClick={() => this.setState({ visible: true }, () => this._getAppointmentInfo())}>
                <WizInput value={value} />
            </div>
        )
    }

    _render() {
        let { mode } = this.props
        return mode === 'edit' ? (
            <>
                {this._renderModal()}
                {this._renderInput()}
            </>
        ) : (
                <>
                    {this._renderCalendar()}
                </>
            )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { siteOrder } = state
    const list = modelUtils.getModelEntity(siteOrder, 'appointmentCalendarList')
    const load = modelUtils.getLoadingState(state, 'siteOrder')
    return {
        list,
        ...load
    }
}

export default connect(mapStateToProps)(AppointmentCalendar)
